<!-- Structure for 3 filter buttons on top of Browse Fundraiser -->
<mat-chip-list *ngIf="origin === 'multipleFilters'" class="desktopMenu">
  <mat-chip class="filter-dropdown" [matMenuTriggerFor]="!isUserLoggedIn ? '' :categoryMenu" (click)="!isUserLoggedIn ? askLogin.emit('filter'): ''">
    <div class="algolia-filters">
      <div class="top-filter-thumb" [innerHTML]="filterData.cause"  *ngIf="attribute === 'category'"></div>
      <div class="top-filter-thumb" [innerHTML]="filterData.tags" *ngIf="attribute === 'tags'"></div>
      <div class="top-filter-thumb" [innerHTML]="filterData.address" *ngIf="attribute === 'address'"></div>
    </div>
    <mat-icon>keyboard_arrow_down</mat-icon>
  </mat-chip>
</mat-chip-list>

<!-- Structure for displaying the list of options once the filter button is clicked (Desktop) -->
<mat-menu #categoryMenu="matMenu" class="menu desktopMenu">
  <ul class="filter-list" *ngIf="attribute === 'category'">
    <li class="filter-item" [ngClass]="{selectedFilter: item.label === filterData.cause}"
      *ngFor="let item of causeValues" [value]="item.value" (click)="selectedFilter(item.label, item.value, 'cause')">
      {{item.label}}</li>
  </ul>
  <ul class="filter-list" *ngIf="attribute === 'tags'">
    <li class="filter-item" [ngClass]="{selectedFilter: item.label === filterData.tags}" *ngFor="let item of tagValues"
      [value]="item.value" (click)="selectedFilter(item.label, item.value, 'tags', 'categoryMenu')">{{item.label}}</li>
  </ul>
  <ul class="filter-list" *ngIf="attribute === 'address'">
    <li class="filter-item" [ngClass]="{selectedFilter: item.label === filterData.address}"
      *ngFor="let item of locationValues" [value]="item.value"
      (click)="selectedFilter(item.label, item.value, 'address')">{{item.label}}</li>
  </ul>
</mat-menu>

<!-- Structure for the categories shown on the sidemenu on desktop -->
<div *ngIf="origin === 'sideMenu'" class="side-menu">
  <ul class="filter-list" *ngIf="attribute === 'category'">
    <li class="filter-item" [ngClass]="{selectedFilter: item.label === filterData.cause}"
      *ngFor="let item of causeValues" [value]="item.value"
      (click)="selectedFilter(item.label, item.value, 'cause', 'sidemenu')">{{item.label}}</li>
  </ul>
</div>

<!-- Structure for the radio type list shown in Mobile -->
<div *ngIf="origin === 'mobileFilters'">
  <div class="filter-list" *ngIf="attribute === 'category'">
    <mat-radio-group aria-labelledby="filter-radio-group-label" class="filter-radio-group"
      [(ngModel)]="filterData.cause">
      <mat-radio-button class="filter-radio-button" *ngFor="let item of causeValues" [value]="item.label"
        (click)="selectedFilter(item.label, item.value, 'cause')">
        {{item.label}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="filter-list" *ngIf="attribute === 'tags'">
    <mat-radio-group aria-labelledby="filter-radio-group-label" class="filter-radio-group"
      [(ngModel)]="filterData.tags">
      <mat-radio-button class="filter-radio-button" *ngFor="let item of tagValues" [value]="item.label"
        (click)="selectedFilter(item.label, item.value, 'tags')">
        {{item.label}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="filter-list" *ngIf="attribute === 'address'">
    <mat-radio-group aria-labelledby="filter-radio-group-label" class="filter-radio-group"
      [(ngModel)]="filterData.address">
      <mat-radio-button class="filter-radio-button" *ngFor="let item of locationValues" [value]="item.label"
        (click)="selectedFilter(item.label, item.value, 'address')">
        {{item.label}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>